import { FunctionComponent } from 'react';
import { ApolloClient } from '@apollo/client';
import { ApolloProvider } from '@apollo/client/react';
import { positions, Provider as AlertProvider, transitions } from 'react-alert';
import AlertTemplate from 'react-alert-template-basic';
import { RouteContext } from 'universal-router';

const alertOptions = {
  position: positions.BOTTOM_RIGHT,
  template: AlertTemplate,
  timeout: 2000,
  transition: transitions.SCALE,
};

type ContextProvidersProps = {
  apolloClient: ApolloClient;
  context: RouteContext;
};

const ContextProviders: FunctionComponent<ContextProvidersProps> = ({
  apolloClient,
  children,
}): JSX.Element => (
  <ApolloProvider client={apolloClient}>
    <AlertProvider {...alertOptions}>{children}</AlertProvider>
  </ApolloProvider>
);

export default ContextProviders;
